// extracted by mini-css-extract-plugin
export default {"blogs":"Blogs_blogs__UZ5qx","blogs__cont":"Blogs_blogs__cont__NqBHo","blogs__cont__card":"Blogs_blogs__cont__card__jBgma"};